<template>
  <v-container>
    <v-row justify="center" class="mr-6" dense>
      <v-col cols="12" lg="5" class="mt-5">
        <v-card color="green" class="mx-auto">
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <v-icon size="50" color="white">
                  thumb_up_alt
                </v-icon>

                <span class="ml-3 white--text">Reportes resueltos</span>

                <p class="number">+{{ getTotalR }}</p>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" lg="5" class="mt-5">
        <v-card color="red darken-1" class="mx-auto">
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <v-icon size="50" color="white">
                  privacy_tip
                </v-icon>

                <span class="ml-3 white--text">Sin resolver</span>
                <p class="number">+{{ getTotalS }}</p>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" lg="5" class="mt-5">
        <v-card color="orange darken-1" class="mx-auto">
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <v-icon size="50" color="white">
                  watch_later
                </v-icon>

                <span class="ml-3 white--text">En proceso</span>
                <p class="number">+{{ getTotalP }}</p>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row justify="center" dense>
      <v-col cols="12" lg="12">
        <v-card>
          <v-card-title class="ml-3">
            <v-speed-dial v-model="fab" :bottom="bottom" :top="top">
              <template v-slot:activator>
                <v-icon v-if="fab">
                  mdi-close
                </v-icon>
                <v-icon>
                  filter_alt
                </v-icon>
                <span class="mr-5">Filtro</span>
              </template>
              <v-btn
                @click="resolvedMethod('Sin resolver')"
                dark
                small
                color="red"
              >
                <v-icon left>
                  sentiment_dissatisfied
                </v-icon>
                Sin Resolver
              </v-btn>
              <v-btn
                @click="resolvedMethod('En proceso')"
                dark
                small
                color="warning"
              >
                <v-icon left>
                  watch_later
                </v-icon>
                En proceso
              </v-btn>
              <v-btn
                @click="resolvedMethod('Resuelto')"
                dark
                small
                color="green"
              >
                <v-icon left>
                  done
                </v-icon>
                Resuelto
              </v-btn>
            </v-speed-dial>
          </v-card-title>

          <v-data-table
            :loading="load"
            :search="search"
            loading-text="Cargando... por favor espere"
            :headers="headers"
            :items="getClaim"
            no-data-text="No hay datos disponible."
            :items-per-page="5"
            class="elevation-1"
          >
            <template v-slot:item.name="{ item }">
              <v-icon size="40">
                mdi-account-circle
              </v-icon>
              <span class="ml-2 ">{{ item.name }}</span>
            </template>

            <template v-slot:item.datePriorirty="{ item }">
              <div>
                {{ item.datePriorirty | date }}
                <br />
                {{ item.resolved == undefined ? "" : "por " + item.resolved }}
              </div>
            </template>
            <template v-slot:item.id="{ item }">
              <v-icon @click="showDialog(item)">
                more_vert
              </v-icon>
            </template>
            <template v-slot:item.status="{ item }">
              <v-btn
                dark
                rounded
                small
                :color="
                  item.status === 'Resuelto'
                    ? 'green'
                    : item.status === 'En proceso'
                    ? 'warning'
                    : 'red'
                "
              >
                <v-icon left>
                  {{
                    item.status === "Resuelto"
                      ? "done"
                      : item.status === "En proceso"
                      ? "watch_later"
                      : "sentiment_dissatisfied"
                  }}
                </v-icon>
                {{ item.status }}
              </v-btn>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="dialog" width="250">
      <v-card>
        <v-card-title>Cambiar Estado</v-card-title>
        <v-card-text>
          <v-checkbox
            v-model="modelR"
            label="Sin resolver"
            color="red"
            dense
            value="Sin resolver"
            hide-details
          ></v-checkbox>

          <v-checkbox
            v-model="modelR"
            label="En proceso"
            color="warning"
            dense
            value="En proceso"
            hide-details
          ></v-checkbox>
          <v-checkbox
            v-model="modelR"
            label="Resuelto"
            color="success"
            dense
            value="Resuelto"
            hide-details
          ></v-checkbox>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" text @click="dialog = false">
            Cancelar
          </v-btn>

          <v-btn :loading="isLoading" color="primary" text @click="updateItem">
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import { formatDate, formatDateNew, formatPhone } from "../../filters";
import { auth } from "../../firebase.config.js";
export default {
  filters: {
    date(timestamp) {
      return formatDateNew(timestamp);
    },
    phone(number) {
      return formatPhone(number);
    },
  },
  data() {
    return {
      claimRequestsData: [],
      fab: false,
      modelR: "",
      item: {},
      bottom: true,
      dialog: false,
      userData: {},
      isLoading: false,
      top: true,
      search: "",
      load: false,
      headers: [
        {
          text: "Detalles del ticket",
          align: "start",
          sortable: false,
          value: "name",
          width: "31%",
        },

        { text: "Teléfono", value: "phone", width: "11%" },
        { text: "Mensaje", value: "description", width: "23%" },
        { text: "Fecha de resolución", value: "datePriorirty", width: "16%" },
        { text: "Estado", value: "status", width: "5%" },
        { text: "", value: "id", width: "5%" },
      ],
    };
  },
  mounted() {
    this.loadInf();
  },
  computed: {
    ...mapGetters(["claimRequests", "usersAdmin"]),
    getClaim() {
      this.claimRequestsData = this.claimRequests.filter(
        (c) => c.status != undefined
      );

      return this.claimRequestsData;
    },
    getTotalR() {
      var ClaimData = this.claimRequestsData.filter((c) =>
        c.status == undefined ? "" : c.status.toLowerCase() == "resuelto"
      );

      return ClaimData.length;
    },
    getTotalS() {
      var ClaimData = this.claimRequestsData.filter((c) =>
        c.status == undefined ? "" : c.status.toLowerCase() == "sin resolver"
      );

      return ClaimData.length;
    },
    getTotalP() {
      var ClaimData = this.claimRequestsData.filter((c) =>
        c.status == undefined ? "" : c.status.toLowerCase() == "en proceso"
      );

      return ClaimData.length;
    },
    user() {
      if (this.usersAdmin == null) {
        return null;
      }
      this.usersAdmin.forEach((element) => {
        if (
          element.email.toLowerCase() == auth.currentUser.email.toLowerCase()
        ) {
          this.userData = element;
        }
      });

      return this.userData;
    },
  },
  methods: {
    ...mapActions(["loadRequests", "updateRequestsClaim"]),
    async loadInf() {
      this.load = true;
      await this.loadRequests();
      this.load = false;
    },
    resolvedMethod(value) {
      this.search = value;
    },
    showDialog(value) {
      this.item = value;
      this.modelR = value.status;
      this.dialog = true;
    },
    async updateItem() {
      if (this.modelR != this.item.status) {
        this.isLoading = true;
        this.item.status = this.modelR;
        this.item.datePriorirty = new Date();
        this.item.resolved = this.user.userName;
        var response = await this.updateRequestsClaim(this.item);
        if (!response) {
          this.$emit("show-snackbar", "Error al cambiar.");
        }
        this.$emit("show-snackbar", "Estatus actualizado");
        await this.loadInf();
        this.isLoading = false;
        this.dialog = false;
      }
    },
  },
};
</script>
<style scoped>
.number {
  margin-left: 15%;
  color: rgb(255, 255, 255);
  font-weight: bold;
  font-size: 3em;
}
</style>
